import * as Sentry from "@sentry/remix";

export default function setSentryError(error: string, context?: object, scope?: any) {
    console.log('Sending sentry error', error, context);
    if (scope) {
        Sentry.withScope((s => {
            s.setLevel(scope.level)
            Sentry.setContext('ErrorMessage', { errorMessage: error });
            if (context) {
                Sentry.setContext('ErrorContext', { context: JSON.stringify(context, null, 4) });
            }

            let errorMessage = `${scope.level} - ${error}`

            Sentry.setContext('ErrorScope', { context: JSON.stringify(scope, null, 4) });
            Sentry.captureEvent(new Error(errorMessage));

        }))
    }
    Sentry.setContext('ErrorMessage', { errorMessage: error })
    if (context) {
        Sentry.setContext('ErrorContext', { context: JSON.stringify(context, null, 4) })
    }
    const sentryError = Sentry.captureException(new Error(error));
    return sentryError;
};

export function setSentryMessage(message: string) {
    Sentry.captureMessage(message);
}


// Options

/**
 * - Real exceptions; errors
 *  - Need to use these only if action is needed
 *      - To use with try catch
 *      - To use in errors on payments, sending in orders, creating parcels
 * - Messages
 *      - Could be log messages
 *      - Needed if no direct action is needed
 *
 */